module.exports = __webpack_public_path__ + "static/media/logo-transparente1.43d519b8.png";